import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import Check from 'framework/Check';
import MerchantFieldLabelMap from 'app/models/typescript/MerchantFieldLabelMap';
import { PriorityViewModel } from 'app/models/PriorityViewModel';
import Utils from '../../../shared/utils';
import { MerchantFieldsService } from '../../../services/merchant-fields.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-components-managecustomer-merchantfields',
    templateUrl: './MerchantFields.component.html'
})
export class MerchantFieldsComponent implements OnInit {
    
    isLoading: boolean;
    merchantFieldLabelMap: MerchantFieldLabelMap;

    @Input() partnerId: number;
    @Input() customerId: number;
    @Input() merchantFields: Boo.Objects.CustomerMerchantFields;

    @Output() refreshCustomer: EventEmitter<void> = new EventEmitter<void>();    

    constructor(private merchantFieldsService: MerchantFieldsService) { }

    ngOnInit() {
        this.isLoading = true;
        this.merchantFieldLabelMap = null;
        this.merchantFieldsService.generateLabelMapping(this.partnerId)
            .pipe(
                finalize(() => this.isLoading = false)
            )
            .subscribe(map => this.merchantFieldLabelMap = map);
    }

    public editMerchantFields(): void {
        PriorityViewModel.show('app-components-managecustomer-merchantfieldsedit', { 
            customerId: this.customerId, 
            partnerId: this.partnerId,
        }).then(() => {
            this.refreshCustomer.emit();
            return Utils.wrapDfd(this.merchantFieldsService.get(this.customerId));
        }).then((merchantFields: Boo.Objects.CustomerMerchantFields) => {
            this.merchantFields = merchantFields;
        });
    }
}
